"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keysOf;

function keysOf(obj) {
  return Object.keys(obj);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJrZXlzT2YiLCJvYmoiLCJPYmplY3QiLCJrZXlzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2tleXNPZi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBrZXlzT2Y8VCBleHRlbmRzIFJlY29yZDxzdHJpbmcsIHVua25vd24+PihvYmo6IFQpIHtcbiAgcmV0dXJuIE9iamVjdC5rZXlzKG9iaikgYXMgQXJyYXk8a2V5b2YgVD5cbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLE1BQVQsQ0FBbURDLEdBQW5ELEVBQTJEO0VBQ3hFLE9BQU9DLE1BQU0sQ0FBQ0MsSUFBUCxDQUFZRixHQUFaLENBQVA7QUFDRCJ9